// 设备管理
export default {
    permission: 'Permission',
    details: 'Details',
    serialNumber: 'Serial Number',
    devicwarrantyPeriodeID: 'Warranty Period',
    totalFlightTime: 'Total Flight Time',
    numberFlights: 'Number of Flights',
    activationTime: 'Activation Time',
    deviceID: 'Device ID',
    equipmentType: 'Equipment Type',
    pleaseChoose: 'Please choose',
    drone: 'Drone',
    RTK: 'RTK',
    weatherStation: 'Weather Station',
    editDevice: 'Edit Device',
    addDevice: 'Add Device',
    snCode: 'SN Code',
    factoryTime: 'Factory Time',
    deviceName: 'Device Name',
    uploadImage: 'Upload Image',
    deviceDetails: 'Device Details',
    permissionSettings: 'Permission settings',
    deviceNameNoreapt: 'The device name already exists and cannot be repeated',
    required: 'Required',
    all: 'All',
    rtk: 'rtk',
    totalEquipment: 'Total Equipment',
    deviceManagement: 'Device Management',
    enterSnCode: 'Please enter SN code',
    isdelDevice: 'After the device is deleted, the device binding relationship will be deleted. Do you want to delete the device?',
    delDevice: 'Delete Device',
    delSuccess: 'Successfully Deleted',
    deviceStatus: 'Device Status',
    networkStatus: 'Network Status',
    entryTime: 'Entry Time',
    permissionStatus: 'permission status',
    versionNumber: 'Version number',
    user: 'User',
    operate: 'Operate',
    shared: 'Shared',
    isShared: 'Shared',
    notShared: 'Not Shared',
    offline: 'Offline',
    online: 'Online',
    test: 'Test',
    pendingSale: 'Pending Sale',
    using: 'Using',
    inMaintenance: 'in maintenance',
    disable: 'Disable',
    scrapped: 'scrapped',
    department: 'Department',
    addDepartment: 'Add department',
    nameQuery: 'Name Query',
    name: 'Name',
    mobilePhone: 'Mobile Phone',
    license: 'License',
    licenseType: 'License Type',
    isName: 'Name',
    deptIsRepeat:'This department already exists! Please select another department',
    selcetHasUserDept:'Please select a department with users',
    cloudTime:'cloud time',
    operationUser:'operation user',
    authorizedTime:'authorized time',
    authorizationDeadline:'authorization deadline',
    cloudDevice:'cloudv device',
    equipmentModel:'equipment model',
    syDeviceNum:'Number of cloud devices authorized by the organization',
    admin: 'Admin',
    tips_AHTH: 'Administrators have the highest authority over all devices',
}
